import { CommonModule }      from '@angular/common';
import { NgModule }          from '@angular/core';
import { ChipItemComponent } from './chip-item.component';


@NgModule( {
	declarations: [
		ChipItemComponent
	],
	imports: [
		// Angular
		CommonModule
	],
	exports: [
		ChipItemComponent
	]
} )
export class ChipItemModule {}
